import { GetCompanySearchResponse } from '@iwoca/lapi-client/edge';

const URL = '/api/companies/search/';

export async function fetchGetMirroredCompanySearch(
  companyName: string,
): Promise<GetCompanySearchResponse> {
  // not via lapi-client as the 'companies' namespace is not included
  // eslint-disable-next-line iwoca/prefer-lapi-client
  const res = await fetch(
    `${URL}?company_name=${encodeURIComponent(companyName)}`,
    {
      credentials: 'same-origin',
    },
  );

  if (!res.ok) {
    throw new Error(`Failed to fetch companies: ${res.statusText}`);
  }

  return res.json() as Promise<GetCompanySearchResponse>;
}
